import { useMemo } from "react";
import type { LeadsBySourceItem } from "api/crm-analytics";
import { PROTECTED_LEAD_SOURCE_NAMES } from "views/settings-crm/slices/utm-mapping/constants";
import { SourceBarChartCard } from "./SourceBarChartCard";

export const LeadsBySourceCard = ({
  data,
  isLoading,
  dateLabel,
  showBoomScreenSources = true
}: {
  data: LeadsBySourceItem[] | undefined;
  isLoading: boolean;
  dateLabel: string;
  showBoomScreenSources?: boolean;
}) => {
  const visibleData = useMemo(
    () =>
      showBoomScreenSources
        ? data
        : data?.filter(
            (item) => !PROTECTED_LEAD_SOURCE_NAMES.has(item.source_name)
          ),
    [data, showBoomScreenSources]
  );
  const onlyInviteLeads =
    !showBoomScreenSources && Boolean(data?.length) && !visibleData?.length;

  return (
    <SourceBarChartCard
      title="Leads by source"
      subtitle={`Lead volume by channel – ${dateLabel}`}
      data={visibleData}
      isLoading={isLoading}
      emptyTitle={
        onlyInviteLeads ? "No leads from marketing channels" : undefined
      }
      emptyDescription={
        onlyInviteLeads
          ? "Every lead in this range came from a screening or applicant invite. Turn on Show BoomScreen sources to see them."
          : undefined
      }
    />
  );
};
